// 广告主相关配置

// 广告主来源
export const aderSource = [{ id: 0, text: '直客' }, { id: 1, text: '代理' }, { id: 2, text: '二代' }];

// 运营方
export const operationSource = [{ id: 0, text: '代理商' }, { id: 1, text: '自运营' }];

// 投放广告位
export const adPosition = [
    { id: '互动位', text: '互动位' },
    { id: '应用商城', text: '应用商城' },
    { id: '信息流', text: '信息流' },
    { id: '米读', text: '米读' },
    { id: '段子', text: '段子' }
];

// 审核结果
export const auditResults = [
    // { id: -2, text: '暂无审核状态' }, // 暂不做无状态处理
    // { id: -1, text: '已删除' },
    { id: 0, text: '待审核' },
    { id: 1, text: '审核驳回' },
    { id: 2, text: '审核通过' }
];

// 广告主类型
export const advType = {
    private: { id: 1, desc: '私海' },
    public: { id: 2, desc: '公海' }
};

// 私海列表排序方式
export const privateListSort = [{ id: 1, text: '按产品绑定时间正序排序' }, { id: 2, text: '按产品释放时间倒序排序' }];

// 公私海列表区分开户和未开户的业务阶段（与common/config?type=1 返回的不同）
export const listSteps = [
    {
        value: '0',
        label: '未开户',
        children: [
            {
                value: '1',
                label: '跟进'
            },
            {
                value: '2',
                label: '广告主接洽'
            },
            {
                value: '3',
                label: '合作提案'
            },
            {
                value: '6',
                label: '待开户'
            },
            {
                value: '4',
                label: '开户中'
            }
        ]
    },
    {
        value: '5',
        label: '已开户'
    }
];
